import { useNftx } from '@nftx/react';
import { useQuery } from '@tanstack/react-query';
import { useBlockNumber } from 'wagmi';
import { QueryKey } from '../../queryKeys';

const useEthereumPrice = (opts?: any) => {
  const blockNumber = useBlockNumber();
  const {
    network,
    core: { fetchEthPrice },
  } = useNftx();
  const enabled = !!blockNumber && opts?.enabled !== false;

  return useQuery(
    [QueryKey.ETHEREUM_PRICE, blockNumber],
    async () => fetchEthPrice({ network }),
    {
      // don't calculate more than once per block
      // but we also don't care about keeping the query after moving to the next block
      staleTime: 60000,
      cacheTime: 0,
      refetchInterval: false,
      ...opts,
      enabled,
    }
  );
};

export default useEthereumPrice;
